// extracted by mini-css-extract-plugin
module.exports = {"container":"QSREmbedHeader_container__BJ4Iz","tableName":"QSREmbedHeader_tableName__jtQVl","tableInfo":"QSREmbedHeader_tableInfo__sqWiS"};